// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { text } from '../../tokens/themeColors/text';
export var dialogColors = function(mode) {
    var bd = border(mode);
    var bg = background(mode);
    var ic = icon(mode);
    var tx = text(mode);
    return {
        default: {
            background: bg.template.dialogs,
            border: bd.default,
            // icon/infoText: consumed directly by app-level dialog content composition
            // (see Dialog.stories.tsx) — MuiDialogContent has no dedicated slot for
            // these since they're arbitrary children, not a themeable MUI part.
            icon: ic.default,
            infoText: tx.status.infoAlt,
            text: tx.primary,
            title: tx.primary
        },
        error: {
            // highlightText/icon/title: MuiDialogTitle only carries the `default`
            // title color (Dialog has no per-severity MUI variant); consumers select
            // these directly per instance (Dialog.stories.tsx).
            highlightText: tx.status.errorAlt,
            icon: ic.status.errorBold2,
            title: tx.primary
        },
        warning: {
            highlightText: tx.status.warningAlt,
            icon: ic.status.warningBold,
            title: tx.primary
        }
    };
};

//# sourceMappingURL=dialogColors.js.map